/**
 * Verse Database Organized by Difficulty
 * Each difficulty level has specific verse references that should be used
 */

export const VERSES_BY_DIFFICULTY = {
  Beginner: [
    // Salvation & Gospel (Most well-known)
    "John 3:16",
    "Romans 3:23",
    "Romans 6:23",
    "Romans 5:8",
    "Romans 10:9",
    "Romans 10:13",
    "Ephesians 2:8-9",
    "John 14:6",
    "Acts 4:12",
    "1 John 1:9",
    "John 1:12",

    // Short, Common Memory Verses
    "Psalm 23:1",
    "Psalm 46:1",
    "Psalm 118:24",
    "Psalm 119:105",
    "Proverbs 3:5",
    "Proverbs 3:6",
    "Genesis 1:1",
    "John 11:35",
    "1 Thessalonians 5:16",
    "1 Thessalonians 5:17",
    "1 Thessalonians 5:18",

    // Strength & Comfort
    "Philippians 4:13",
    "Philippians 4:6",
    "Philippians 4:7",
    "Isaiah 41:10",
    "Joshua 1:9",
    "Matthew 11:28",
    "Jeremiah 29:11",
    "2 Timothy 1:7",
    "1 Peter 5:7",
    "Psalm 56:3",

    // Love & Commandments
    "1 John 4:19",
    "1 John 4:8",
    "John 13:34",
    "John 15:12",
    "Matthew 22:37",
    "Matthew 22:39",

    // Prayer & Faith
    "Matthew 7:7",
    "Matthew 21:22",
    "James 1:5",
    "James 5:16",
    "Hebrews 11:1",
    "Hebrews 11:6",

    // Additional Common Verses
    "Matthew 28:19",
    "Matthew 28:20",
    "2 Corinthians 5:17",
    "Galatians 2:20",
    "1 Corinthians 10:13",
    "Romans 8:28",
    "Psalm 27:1",
    "Matthew 6:33",
    "Proverbs 16:3",
    "Isaiah 40:31"
  ],

  Intermediate: [
    // Deeper Theological Concepts
    "Romans 8:1",
    "Romans 8:38-39",
    "Romans 12:1",
    "Romans 12:2",
    "Galatians 5:22-23",
    "Ephesians 6:10",
    "Ephesians 6:11",
    "Colossians 3:23",
    "2 Corinthians 5:21",
    "2 Corinthians 12:9",

    // Character & Sanctification
    "James 1:2-3",
    "James 1:22",
    "James 4:7",
    "James 4:8",
    "1 Peter 2:9",
    "1 Peter 3:15",
    "2 Peter 1:5-7",
    "2 Peter 3:9",

    // Spiritual Warfare & Victory
    "1 John 4:4",
    "1 John 5:4",
    "Ephesians 6:12",
    "Ephesians 6:13",
    "2 Corinthians 10:4-5",

    // Wisdom & Knowledge
    "Proverbs 9:10",
    "Proverbs 14:12",
    "Proverbs 16:18",
    "Proverbs 18:10",
    "Proverbs 22:6",
    "Proverbs 27:17",
    "Ecclesiastes 12:13",

    // Messianic Prophecies
    "Isaiah 53:5",
    "Isaiah 53:6",
    "Isaiah 9:6",
    "Micah 5:2",
    "Psalm 22:1",

    // New Testament Teaching
    "Matthew 5:14",
    "Matthew 5:16",
    "Matthew 6:19-20",
    "Matthew 6:24",
    "Matthew 7:12",
    "Luke 6:27",
    "Luke 6:31",
    "John 3:3",
    "John 8:32",
    "John 10:10",
    "John 15:5",
    "Acts 1:8",
    "Acts 16:31",

    // Pauline Epistles
    "1 Corinthians 6:19-20",
    "1 Corinthians 13:4-7",
    "1 Corinthians 15:3-4",
    "1 Corinthians 15:58",
    "2 Timothy 2:15",
    "2 Timothy 3:16",
    "2 Timothy 4:7",
    "Titus 3:5",
    "Hebrews 12:1",
    "Hebrews 12:2",
    "Hebrews 13:8",

    // Psalms & Praise
    "Psalm 1:1-2",
    "Psalm 19:14",
    "Psalm 34:8",
    "Psalm 37:4",
    "Psalm 51:10",
    "Psalm 100:4",
    "Psalm 103:12",
    "Psalm 139:14"
  ],

  Advanced: [
    // Complex Theological Passages
    "Romans 3:21-24",
    "Romans 5:1-2",
    "Romans 6:1-2",
    "Romans 8:5-6",
    "Romans 8:26-27",
    "Romans 11:33-36",
    "1 Corinthians 1:18",
    "1 Corinthians 2:9-10",
    "1 Corinthians 3:16",
    "2 Corinthians 3:17-18",
    "2 Corinthians 4:16-18",
    "2 Corinthians 6:14",

    // Ephesians Deep Doctrine
    "Ephesians 1:3-4",
    "Ephesians 1:7-8",
    "Ephesians 1:13-14",
    "Ephesians 2:1-3",
    "Ephesians 2:4-5",
    "Ephesians 2:10",
    "Ephesians 3:16-19",
    "Ephesians 3:20-21",
    "Ephesians 4:11-13",
    "Ephesians 4:29-30",
    "Ephesians 5:18-20",
    "Ephesians 6:14-17",

    // Philippians & Colossians
    "Philippians 1:6",
    "Philippians 2:3-4",
    "Philippians 2:5-8",
    "Philippians 2:9-11",
    "Philippians 3:7-8",
    "Philippians 3:13-14",
    "Colossians 1:15-17",
    "Colossians 1:19-20",
    "Colossians 2:13-14",
    "Colossians 3:1-2",
    "Colossians 3:12-14",

    // Hebrews Christology
    "Hebrews 1:1-3",
    "Hebrews 2:14-15",
    "Hebrews 4:12",
    "Hebrews 4:14-16",
    "Hebrews 9:27-28",
    "Hebrews 10:24-25",
    "Hebrews 11:3",
    "Hebrews 12:28-29",
    "Hebrews 13:5-6",

    // James & Peter
    "James 1:12",
    "James 1:17",
    "James 2:17",
    "James 3:5-6",
    "1 Peter 1:3-5",
    "1 Peter 1:18-19",
    "1 Peter 2:24",
    "1 Peter 4:10",
    "2 Peter 1:20-21",

    // Johannine Writings
    "1 John 1:7",
    "1 John 2:1-2",
    "1 John 2:15-17",
    "1 John 3:1",
    "1 John 3:16",
    "1 John 3:18",
    "1 John 5:11-13",
    "Revelation 1:8",
    "Revelation 3:20",
    "Revelation 21:4",
    "Revelation 22:13",

    // Old Testament Wisdom & Prophecy
    "Job 19:25-26",
    "Psalm 8:3-4",
    "Psalm 16:11",
    "Psalm 32:8",
    "Psalm 73:25-26",
    "Psalm 90:12",
    "Psalm 119:9-11",
    "Psalm 119:165",
    "Psalm 121:1-2",
    "Psalm 127:1",
    "Psalm 139:23-24",
    "Proverbs 1:7",
    "Proverbs 4:23",
    "Proverbs 6:16-19",
    "Proverbs 11:24-25",
    "Proverbs 13:20",
    "Proverbs 15:1",
    "Proverbs 25:21-22",
    "Proverbs 29:18",
    "Isaiah 6:8",
    "Isaiah 7:14",
    "Isaiah 26:3",
    "Isaiah 43:1-2",
    "Isaiah 55:6-7",
    "Isaiah 55:8-9",
    "Isaiah 64:6",
    "Jeremiah 1:5",
    "Jeremiah 17:9",
    "Jeremiah 31:3",
    "Jeremiah 33:3",
    "Ezekiel 36:26",
    "Daniel 12:3",
    "Hosea 6:3",
    "Joel 2:28",
    "Micah 6:8",
    "Nahum 1:7",
    "Habakkuk 2:14",
    "Habakkuk 3:17-18",
    "Zephaniah 3:17",
    "Zechariah 4:6",
    "Malachi 3:10"
  ],

  "Eli Challenge": [
    // THE ULTIMATE CHALLENGE - Verses from across the entire Bible
    // Named after Eli the priest who trained Samuel

    // PENTATEUCH (Torah)
    // Genesis - Creation & Patriarchs
    "Genesis 1:26-27",
    "Genesis 1:31",
    "Genesis 2:7",
    "Genesis 2:18",
    "Genesis 2:24",
    "Genesis 3:15",
    "Genesis 6:5",
    "Genesis 12:1-3",
    "Genesis 15:6",
    "Genesis 22:14",
    "Genesis 28:15",
    "Genesis 50:20",

    // Exodus - Deliverance & Law
    "Exodus 3:14",
    "Exodus 12:13",
    "Exodus 14:14",
    "Exodus 15:2",
    "Exodus 19:5-6",
    "Exodus 20:3",
    "Exodus 20:12",
    "Exodus 33:14",
    "Exodus 34:6-7",

    // Leviticus - Holiness
    "Leviticus 11:44-45",
    "Leviticus 19:2",
    "Leviticus 19:18",
    "Leviticus 26:12",

    // Numbers - Wilderness Journey
    "Numbers 6:24-26",
    "Numbers 14:18",
    "Numbers 23:19",

    // Deuteronomy - Covenant Renewal
    "Deuteronomy 4:29",
    "Deuteronomy 6:4-5",
    "Deuteronomy 7:9",
    "Deuteronomy 8:3",
    "Deuteronomy 10:12-13",
    "Deuteronomy 30:19-20",
    "Deuteronomy 31:6",
    "Deuteronomy 31:8",
    "Deuteronomy 32:4",
    "Deuteronomy 33:27",

    // HISTORICAL BOOKS
    // Joshua - Conquest
    "Joshua 1:8",
    "Joshua 23:14",
    "Joshua 24:15",

    // Judges - Cycles
    "Judges 2:18",
    "Judges 21:25",

    // Ruth - Redemption
    "Ruth 1:16",

    // 1 Samuel - Kingship
    "1 Samuel 2:2",
    "1 Samuel 12:24",
    "1 Samuel 15:22",
    "1 Samuel 16:7",

    // 2 Samuel - David's Reign
    "2 Samuel 7:28",
    "2 Samuel 22:2-3",
    "2 Samuel 22:31",

    // 1 Kings - Temple & Division
    "1 Kings 8:27",
    "1 Kings 8:39",
    "1 Kings 18:21",

    // 2 Kings - Decline
    "2 Kings 17:13",

    // 1 Chronicles - Genealogy & Worship
    "1 Chronicles 16:11",
    "1 Chronicles 16:34",
    "1 Chronicles 29:11",

    // 2 Chronicles - Temple History
    "2 Chronicles 7:14",
    "2 Chronicles 16:9",
    "2 Chronicles 20:15",

    // Ezra - Restoration
    "Ezra 7:10",

    // Nehemiah - Rebuilding
    "Nehemiah 8:10",

    // Esther - Providence
    "Esther 4:14",

    // WISDOM LITERATURE
    // Job - Suffering
    "Job 1:21",
    "Job 13:15",
    "Job 23:10",
    "Job 42:2",

    // Psalms - Worship & Prayer
    "Psalm 1:3",
    "Psalm 2:11-12",
    "Psalm 4:8",
    "Psalm 5:3",
    "Psalm 9:1-2",
    "Psalm 18:2",
    "Psalm 18:30",
    "Psalm 19:1",
    "Psalm 19:7-8",
    "Psalm 23:4",
    "Psalm 23:6",
    "Psalm 24:1",
    "Psalm 25:4-5",
    "Psalm 27:4",
    "Psalm 27:14",
    "Psalm 28:7",
    "Psalm 29:2",
    "Psalm 30:5",
    "Psalm 31:15",
    "Psalm 32:1-2",
    "Psalm 33:20-22",
    "Psalm 34:1",
    "Psalm 34:18",
    "Psalm 36:5-6",
    "Psalm 37:23-24",
    "Psalm 40:1-2",
    "Psalm 42:1-2",
    "Psalm 46:10",
    "Psalm 51:1-2",
    "Psalm 51:17",
    "Psalm 62:5-6",
    "Psalm 63:1",
    "Psalm 66:18-20",
    "Psalm 68:19",
    "Psalm 84:11-12",
    "Psalm 86:5",
    "Psalm 91:1-2",
    "Psalm 92:1-2",
    "Psalm 95:1-2",
    "Psalm 96:2-3",
    "Psalm 100:1-3",
    "Psalm 103:1-2",
    "Psalm 103:8",
    "Psalm 103:17",
    "Psalm 104:33-34",
    "Psalm 107:1",
    "Psalm 111:10",
    "Psalm 115:1",
    "Psalm 116:1-2",
    "Psalm 118:8",
    "Psalm 119:1-2",
    "Psalm 119:18",
    "Psalm 119:50",
    "Psalm 119:89",
    "Psalm 119:133",
    "Psalm 119:160",
    "Psalm 121:7-8",
    "Psalm 130:5",
    "Psalm 133:1",
    "Psalm 136:1",
    "Psalm 139:1-2",
    "Psalm 143:8",
    "Psalm 145:3",
    "Psalm 145:18-19",
    "Psalm 147:3",
    "Psalm 150:6",

    // Proverbs - Practical Wisdom
    "Proverbs 2:6",
    "Proverbs 3:9-10",
    "Proverbs 8:17",
    "Proverbs 10:12",
    "Proverbs 12:15",
    "Proverbs 14:29",
    "Proverbs 15:3",
    "Proverbs 17:17",
    "Proverbs 18:24",
    "Proverbs 19:21",
    "Proverbs 20:24",
    "Proverbs 21:2",
    "Proverbs 23:17-18",
    "Proverbs 28:13",
    "Proverbs 30:5",
    "Proverbs 31:25-26",

    // Ecclesiastes - Meaning
    "Ecclesiastes 3:1",
    "Ecclesiastes 3:11",
    "Ecclesiastes 5:10",
    "Ecclesiastes 7:8",
    "Ecclesiastes 9:11",
    "Ecclesiastes 11:9",

    // Song of Solomon - Love
    "Song of Solomon 2:16",
    "Song of Solomon 8:6-7",

    // MAJOR PROPHETS
    // Isaiah - Messiah
    "Isaiah 1:18",
    "Isaiah 12:2",
    "Isaiah 25:1",
    "Isaiah 30:21",
    "Isaiah 40:8",
    "Isaiah 40:28-29",
    "Isaiah 41:13",
    "Isaiah 43:25",
    "Isaiah 44:22",
    "Isaiah 46:4",
    "Isaiah 48:17",
    "Isaiah 49:15-16",
    "Isaiah 50:4",
    "Isaiah 52:7",
    "Isaiah 54:10",
    "Isaiah 54:17",
    "Isaiah 55:11",
    "Isaiah 57:15",
    "Isaiah 58:11",
    "Isaiah 59:1",
    "Isaiah 60:1",
    "Isaiah 61:1-3",
    "Isaiah 62:4",
    "Isaiah 65:24",
    "Isaiah 66:2",

    // Jeremiah - Judgment & Hope
    "Jeremiah 9:23-24",
    "Jeremiah 10:12",
    "Jeremiah 15:16",
    "Jeremiah 23:24",
    "Jeremiah 24:7",
    "Jeremiah 29:12-13",
    "Jeremiah 30:17",
    "Jeremiah 32:17",
    "Jeremiah 32:27",

    // Lamentations - Mourning
    "Lamentations 3:22-23",
    "Lamentations 3:25-26",
    "Lamentations 3:40",

    // Ezekiel - Vision & Restoration
    "Ezekiel 11:19",
    "Ezekiel 18:31-32",
    "Ezekiel 34:11",
    "Ezekiel 37:14",

    // Daniel - Sovereignty
    "Daniel 2:20-22",
    "Daniel 2:44",
    "Daniel 3:17-18",
    "Daniel 6:26-27",

    // MINOR PROPHETS
    // Hosea - Covenant Love
    "Hosea 2:19-20",
    "Hosea 10:12",
    "Hosea 14:4",

    // Joel - Spirit Outpouring
    "Joel 2:12-13",
    "Joel 2:25",
    "Joel 2:32",

    // Amos - Justice
    "Amos 5:4",
    "Amos 5:24",

    // Obadiah - Pride & Justice
    "Obadiah 1:15",

    // Jonah - Compassion
    "Jonah 2:8-9",

    // Micah - Requirements
    "Micah 7:18-19",

    // Nahum - Vengeance
    "Nahum 1:3",

    // Habakkuk - Faith
    "Habakkuk 2:4",
    "Habakkuk 2:20",

    // Zephaniah - Restoration
    "Zephaniah 3:9",

    // Haggai - Priorities
    "Haggai 2:9",

    // Zechariah - Future Hope
    "Zechariah 2:10-11",
    "Zechariah 8:16-17",
    "Zechariah 9:9",

    // Malachi - Final Warning
    "Malachi 3:6",
    "Malachi 4:2",

    // NEW TESTAMENT
    // GOSPELS
    // Matthew - Kingdom
    "Matthew 1:21",
    "Matthew 1:23",
    "Matthew 3:2",
    "Matthew 4:4",
    "Matthew 4:19",
    "Matthew 5:3-4",
    "Matthew 5:8",
    "Matthew 5:10-12",
    "Matthew 5:43-45",
    "Matthew 5:48",
    "Matthew 6:9-10",
    "Matthew 6:14-15",
    "Matthew 6:21",
    "Matthew 6:25-26",
    "Matthew 6:34",
    "Matthew 7:1-2",
    "Matthew 7:13-14",
    "Matthew 7:24-25",
    "Matthew 9:12-13",
    "Matthew 10:28",
    "Matthew 10:32-33",
    "Matthew 11:29-30",
    "Matthew 12:36-37",
    "Matthew 13:44",
    "Matthew 16:18",
    "Matthew 16:24",
    "Matthew 16:26",
    "Matthew 18:19-20",
    "Matthew 19:26",
    "Matthew 20:26-28",
    "Matthew 22:37-38",
    "Matthew 24:35",
    "Matthew 25:21",
    "Matthew 25:40",
    "Matthew 26:41",

    // Mark - Servant
    "Mark 1:15",
    "Mark 8:34-35",
    "Mark 9:23",
    "Mark 10:27",
    "Mark 10:43-45",
    "Mark 11:24",
    "Mark 12:30-31",
    "Mark 16:15",

    // Luke - Savior
    "Luke 1:37",
    "Luke 1:45",
    "Luke 2:10-11",
    "Luke 4:18-19",
    "Luke 5:31-32",
    "Luke 6:35-36",
    "Luke 6:37-38",
    "Luke 9:23-24",
    "Luke 10:27",
    "Luke 11:9-10",
    "Luke 12:6-7",
    "Luke 12:15",
    "Luke 12:22-23",
    "Luke 12:32",
    "Luke 15:7",
    "Luke 15:10",
    "Luke 17:5-6",
    "Luke 18:27",
    "Luke 19:10",
    "Luke 21:33",
    "Luke 24:6-7",

    // John - Son of God
    "John 1:1",
    "John 1:14",
    "John 1:29",
    "John 3:17-18",
    "John 3:30",
    "John 3:36",
    "John 4:23-24",
    "John 5:24",
    "John 6:35",
    "John 6:37",
    "John 6:40",
    "John 6:47",
    "John 6:51",
    "John 7:37-38",
    "John 8:12",
    "John 8:36",
    "John 10:9-10",
    "John 10:14",
    "John 10:27-28",
    "John 11:25-26",
    "John 12:46",
    "John 13:35",
    "John 14:1-3",
    "John 14:15-17",
    "John 14:21",
    "John 14:23",
    "John 14:26-27",
    "John 15:4-5",
    "John 15:7",
    "John 15:9-11",
    "John 15:13",
    "John 15:16",
    "John 16:13",
    "John 16:33",
    "John 17:3",
    "John 20:29",
    "John 20:31",

    // Acts - Church
    "Acts 2:21",
    "Acts 2:38-39",
    "Acts 2:42",
    "Acts 3:19",
    "Acts 4:29-31",
    "Acts 5:29",
    "Acts 10:34-35",
    "Acts 17:11",
    "Acts 17:24-25",
    "Acts 17:27-28",
    "Acts 20:35",

    // PAULINE EPISTLES
    // Romans - Righteousness
    "Romans 1:16-17",
    "Romans 2:6-8",
    "Romans 3:10",
    "Romans 4:3",
    "Romans 5:3-5",
    "Romans 6:4",
    "Romans 6:11",
    "Romans 6:22-23",
    "Romans 7:18",
    "Romans 8:2",
    "Romans 8:6",
    "Romans 8:9",
    "Romans 8:11",
    "Romans 8:14-15",
    "Romans 8:16-17",
    "Romans 8:18",
    "Romans 8:31",
    "Romans 8:32",
    "Romans 8:35",
    "Romans 9:16",
    "Romans 10:17",
    "Romans 11:29",
    "Romans 12:3",
    "Romans 12:9-10",
    "Romans 12:12",
    "Romans 12:18-19",
    "Romans 12:21",
    "Romans 13:8",
    "Romans 13:14",
    "Romans 14:7-8",
    "Romans 14:12",
    "Romans 14:17-19",
    "Romans 15:4",
    "Romans 15:13",

    // 1 Corinthians - Church Issues
    "1 Corinthians 1:10",
    "1 Corinthians 2:12",
    "1 Corinthians 3:6-7",
    "1 Corinthians 6:11",
    "1 Corinthians 9:24-25",
    "1 Corinthians 10:12",
    "1 Corinthians 10:31",
    "1 Corinthians 12:4-6",
    "1 Corinthians 12:12-13",
    "1 Corinthians 12:27",
    "1 Corinthians 13:1-3",
    "1 Corinthians 13:8",
    "1 Corinthians 13:13",
    "1 Corinthians 14:1",
    "1 Corinthians 15:20",
    "1 Corinthians 15:55-57",
    "1 Corinthians 16:13-14",

    // 2 Corinthians - Ministry
    "2 Corinthians 1:3-4",
    "2 Corinthians 1:20",
    "2 Corinthians 3:5",
    "2 Corinthians 4:7-8",
    "2 Corinthians 5:7",
    "2 Corinthians 5:14-15",
    "2 Corinthians 5:18-19",
    "2 Corinthians 5:20",
    "2 Corinthians 7:10",
    "2 Corinthians 8:9",
    "2 Corinthians 9:6-8",
    "2 Corinthians 10:3-4",
    "2 Corinthians 12:10",
    "2 Corinthians 13:11",

    // Galatians - Freedom
    "Galatians 1:10",
    "Galatians 3:26-28",
    "Galatians 5:1",
    "Galatians 5:13-14",
    "Galatians 5:16-17",
    "Galatians 5:24-25",
    "Galatians 6:2",
    "Galatians 6:4-5",
    "Galatians 6:7-9",
    "Galatians 6:14",

    // Ephesians - Unity
    "Ephesians 1:5-6",
    "Ephesians 1:11",
    "Ephesians 2:8",
    "Ephesians 2:19-20",
    "Ephesians 3:12",
    "Ephesians 4:1-3",
    "Ephesians 4:22-24",
    "Ephesians 4:26-27",
    "Ephesians 4:31-32",
    "Ephesians 5:1-2",
    "Ephesians 5:8-9",
    "Ephesians 5:15-16",
    "Ephesians 5:25-26",
    "Ephesians 6:1-3",
    "Ephesians 6:18",

    // Philippians - Joy
    "Philippians 1:21",
    "Philippians 2:13-14",
    "Philippians 3:10",
    "Philippians 3:20-21",
    "Philippians 4:4",
    "Philippians 4:8",
    "Philippians 4:11-12",
    "Philippians 4:19",

    // Colossians - Supremacy
    "Colossians 1:9-10",
    "Colossians 1:13-14",
    "Colossians 2:6-7",
    "Colossians 2:9-10",
    "Colossians 3:3-4",
    "Colossians 3:15-17",
    "Colossians 4:2",
    "Colossians 4:5-6",

    // 1 Thessalonians - Return
    "1 Thessalonians 1:3",
    "1 Thessalonians 4:11-12",
    "1 Thessalonians 4:13-14",
    "1 Thessalonians 5:11",
    "1 Thessalonians 5:23-24",

    // 2 Thessalonians - Endurance
    "2 Thessalonians 2:16-17",
    "2 Thessalonians 3:3",
    "2 Thessalonians 3:5",

    // 1 Timothy - Church Leadership
    "1 Timothy 1:15",
    "1 Timothy 2:3-5",
    "1 Timothy 4:12",
    "1 Timothy 4:16",
    "1 Timothy 6:6-8",
    "1 Timothy 6:10-12",
    "1 Timothy 6:17-19",

    // 2 Timothy - Perseverance
    "2 Timothy 1:8-9",
    "2 Timothy 2:3-4",
    "2 Timothy 2:11-13",
    "2 Timothy 2:22",
    "2 Timothy 3:14-15",
    "2 Timothy 4:2",
    "2 Timothy 4:17-18",

    // Titus - Sound Doctrine
    "Titus 2:11-12",
    "Titus 3:4-5",

    // Philemon - Forgiveness
    "Philemon 1:6",

    // Hebrews - Superiority of Christ
    "Hebrews 2:1",
    "Hebrews 3:13",
    "Hebrews 4:9-10",
    "Hebrews 6:10",
    "Hebrews 6:19",
    "Hebrews 7:25",
    "Hebrews 10:19-22",
    "Hebrews 10:35-36",
    "Hebrews 11:1",
    "Hebrews 11:6",
    "Hebrews 13:15-16",

    // GENERAL EPISTLES
    // James - Faith & Works
    "James 1:2-4",
    "James 1:19-20",
    "James 2:14-17",
    "James 4:6",
    "James 4:10",
    "James 5:13",
    "James 5:16",

    // 1 Peter - Suffering & Glory
    "1 Peter 1:6-7",
    "1 Peter 1:15-16",
    "1 Peter 2:2-3",
    "1 Peter 2:11-12",
    "1 Peter 2:21",
    "1 Peter 3:8-9",
    "1 Peter 3:18",
    "1 Peter 4:7-8",
    "1 Peter 5:6-7",
    "1 Peter 5:8-9",
    "1 Peter 5:10",

    // 2 Peter - Growth & Truth
    "2 Peter 1:3-4",
    "2 Peter 3:8",
    "2 Peter 3:18",

    // 1 John - Assurance
    "1 John 1:5",
    "1 John 1:8-9",
    "1 John 2:5-6",
    "1 John 3:20",
    "1 John 4:7-8",
    "1 John 4:10-11",
    "1 John 4:16",
    "1 John 4:18",
    "1 John 5:3-4",
    "1 John 5:14-15",

    // 2 John - Walk in Truth
    "2 John 1:6",

    // 3 John - Support Truth
    "3 John 1:4",

    // Jude - Contend for Faith
    "Jude 1:20-21",
    "Jude 1:24-25",

    // Revelation - Victory & Hope
    "Revelation 1:5-6",
    "Revelation 2:10",
    "Revelation 3:5",
    "Revelation 3:21",
    "Revelation 4:8",
    "Revelation 4:11",
    "Revelation 5:9-10",
    "Revelation 7:9",
    "Revelation 7:17",
    "Revelation 11:15",
    "Revelation 12:11",
    "Revelation 14:13",
    "Revelation 19:6-7",
    "Revelation 21:1-2",
    "Revelation 21:3-4",
    "Revelation 22:1-2",
    "Revelation 22:17",
    "Revelation 22:20-21",

    // EXPANDED COVERAGE - Additional verses for comprehensive Bible mastery (676 -> 1000)

    // More Genesis - Foundations
    "Genesis 1:2-3",
    "Genesis 1:28",
    "Genesis 3:6",
    "Genesis 3:9",
    "Genesis 4:7",
    "Genesis 5:24",
    "Genesis 6:8-9",
    "Genesis 8:21-22",
    "Genesis 9:6",
    "Genesis 11:4",
    "Genesis 13:8",
    "Genesis 15:1",
    "Genesis 17:1",
    "Genesis 18:14",
    "Genesis 18:25",
    "Genesis 21:1-2",
    "Genesis 22:8",
    "Genesis 25:23",
    "Genesis 26:24",
    "Genesis 28:12",
    "Genesis 32:28",
    "Genesis 37:4",
    "Genesis 39:9",
    "Genesis 41:16",
    "Genesis 45:5",
    "Genesis 45:8",
    "Genesis 48:16",
    "Genesis 49:10",

    // More Exodus - Deliverance
    "Exodus 4:11-12",
    "Exodus 6:6-7",
    "Exodus 13:21",
    "Exodus 14:13",
    "Exodus 15:11",
    "Exodus 15:26",
    "Exodus 16:4",
    "Exodus 17:15",
    "Exodus 19:4",
    "Exodus 20:2",
    "Exodus 20:6",
    "Exodus 20:8",
    "Exodus 23:25",
    "Exodus 31:13",
    "Exodus 32:26",
    "Exodus 33:19",
    "Exodus 34:14",

    // More Leviticus - Holiness Code
    "Leviticus 6:13",
    "Leviticus 10:3",
    "Leviticus 16:30",
    "Leviticus 17:11",
    "Leviticus 18:5",
    "Leviticus 20:7-8",
    "Leviticus 22:32-33",
    "Leviticus 25:23",

    // More Numbers - Journey
    "Numbers 6:22-23",
    "Numbers 10:29",
    "Numbers 11:23",
    "Numbers 12:6-8",
    "Numbers 13:30",
    "Numbers 14:8-9",
    "Numbers 15:39",
    "Numbers 21:8-9",
    "Numbers 24:17",

    // More Deuteronomy - Covenant
    "Deuteronomy 1:21",
    "Deuteronomy 3:22",
    "Deuteronomy 4:7",
    "Deuteronomy 4:9",
    "Deuteronomy 4:31",
    "Deuteronomy 4:39",
    "Deuteronomy 5:29",
    "Deuteronomy 6:6-7",
    "Deuteronomy 7:6",
    "Deuteronomy 8:2",
    "Deuteronomy 11:18-19",
    "Deuteronomy 12:28",
    "Deuteronomy 13:4",
    "Deuteronomy 15:10",
    "Deuteronomy 18:15",
    "Deuteronomy 28:1-2",
    "Deuteronomy 29:29",
    "Deuteronomy 30:6",
    "Deuteronomy 30:16",
    "Deuteronomy 31:23",

    // More Joshua - Conquest & Faith
    "Joshua 1:5",
    "Joshua 3:5",
    "Joshua 4:24",
    "Joshua 6:16",
    "Joshua 10:25",
    "Joshua 11:15",
    "Joshua 14:8",
    "Joshua 21:45",
    "Joshua 22:5",
    "Joshua 23:11",

    // More Judges - Deliverance
    "Judges 5:31",
    "Judges 6:12",
    "Judges 6:14",
    "Judges 7:2",
    "Judges 10:15",
    "Judges 16:28",

    // Ruth - Complete story
    "Ruth 1:16-17",
    "Ruth 2:12",
    "Ruth 3:11",
    "Ruth 4:14",

    // More 1 Samuel - Kings & Prophets
    "1 Samuel 2:9",
    "1 Samuel 3:9-10",
    "1 Samuel 7:3",
    "1 Samuel 7:12",
    "1 Samuel 10:6",
    "1 Samuel 12:22",
    "1 Samuel 13:14",
    "1 Samuel 15:29",
    "1 Samuel 17:45",
    "1 Samuel 17:47",
    "1 Samuel 24:12",
    "1 Samuel 26:23",

    // More 2 Samuel - David's Kingdom
    "2 Samuel 5:10",
    "2 Samuel 6:14",
    "2 Samuel 7:22",
    "2 Samuel 12:13",
    "2 Samuel 14:14",
    "2 Samuel 15:26",
    "2 Samuel 22:29",
    "2 Samuel 23:3-4",
    "2 Samuel 24:14",

    // More 1 Kings - Wisdom & Decline
    "1 Kings 2:3",
    "1 Kings 3:9",
    "1 Kings 8:23",
    "1 Kings 8:61",
    "1 Kings 11:38",
    "1 Kings 17:1",
    "1 Kings 18:39",
    "1 Kings 19:12",

    // More 2 Kings - Prophets & Fall
    "2 Kings 2:9",
    "2 Kings 4:26",
    "2 Kings 5:15",
    "2 Kings 6:16",
    "2 Kings 18:5",
    "2 Kings 19:19",
    "2 Kings 20:5",
    "2 Kings 23:25",

    // More 1 Chronicles - Worship
    "1 Chronicles 4:10",
    "1 Chronicles 16:8-9",
    "1 Chronicles 16:23-24",
    "1 Chronicles 16:29",
    "1 Chronicles 17:20",
    "1 Chronicles 22:13",
    "1 Chronicles 28:9",
    "1 Chronicles 28:20",
    "1 Chronicles 29:14",

    // More 2 Chronicles - Temple & Revival
    "2 Chronicles 1:10",
    "2 Chronicles 6:14",
    "2 Chronicles 15:2",
    "2 Chronicles 15:7",
    "2 Chronicles 19:11",
    "2 Chronicles 20:12",
    "2 Chronicles 20:17",
    "2 Chronicles 26:5",
    "2 Chronicles 30:9",
    "2 Chronicles 32:7-8",

    // More Ezra - Return & Restoration
    "Ezra 1:3",
    "Ezra 3:11",
    "Ezra 6:22",
    "Ezra 8:22",
    "Ezra 9:9",
    "Ezra 10:4",

    // More Nehemiah - Rebuilding
    "Nehemiah 1:11",
    "Nehemiah 2:20",
    "Nehemiah 4:6",
    "Nehemiah 4:14",
    "Nehemiah 6:9",
    "Nehemiah 9:6",
    "Nehemiah 9:17",
    "Nehemiah 9:31",

    // More Esther - Providence
    "Esther 2:17",
    "Esther 4:16",
    "Esther 6:1",
    "Esther 8:17",

    // More Job - Suffering & Wisdom
    "Job 2:10",
    "Job 5:17",
    "Job 8:21",
    "Job 11:7-8",
    "Job 12:13",
    "Job 14:14",
    "Job 19:25",
    "Job 22:21",
    "Job 26:7",
    "Job 28:28",
    "Job 33:4",
    "Job 36:26",
    "Job 37:5",
    "Job 38:4",
    "Job 40:8",
    "Job 42:5",

    // More Psalms - Praise & Prayer (Expanding the most important book for memory)
    "Psalm 3:3",
    "Psalm 6:9",
    "Psalm 7:17",
    "Psalm 9:9-10",
    "Psalm 10:17",
    "Psalm 11:7",
    "Psalm 12:6",
    "Psalm 13:5-6",
    "Psalm 14:1",
    "Psalm 15:1-2",
    "Psalm 16:8",
    "Psalm 17:15",
    "Psalm 18:1-2",
    "Psalm 19:10",
    "Psalm 20:7",
    "Psalm 22:22",
    "Psalm 23:2-3",
    "Psalm 25:10",
    "Psalm 26:2-3",
    "Psalm 27:8",
    "Psalm 28:6-7",
    "Psalm 29:11",
    "Psalm 31:3",
    "Psalm 31:24",
    "Psalm 32:5",
    "Psalm 33:4-5",
    "Psalm 33:11",
    "Psalm 33:18",
    "Psalm 34:3-4",
    "Psalm 34:9-10",
    "Psalm 34:14-15",
    "Psalm 34:17",
    "Psalm 35:9",
    "Psalm 37:3-4",
    "Psalm 37:5-6",
    "Psalm 37:7",
    "Psalm 38:15",
    "Psalm 39:7",
    "Psalm 40:8",
    "Psalm 41:1",
    "Psalm 42:5",
    "Psalm 42:11",
    "Psalm 43:3",
    "Psalm 43:5",
    "Psalm 44:8",
    "Psalm 45:1",
    "Psalm 46:5",
    "Psalm 47:1-2",
    "Psalm 48:14",
    "Psalm 50:15",
    "Psalm 51:10",
    "Psalm 51:12",
    "Psalm 52:8",
    "Psalm 54:4",
    "Psalm 55:16",
    "Psalm 55:22",
    "Psalm 56:11",
    "Psalm 57:1",
    "Psalm 59:16-17",
    "Psalm 61:1-2",
    "Psalm 62:1-2",
    "Psalm 62:8",
    "Psalm 63:3",
    "Psalm 65:1-2",
    "Psalm 66:16",
    "Psalm 67:1-2",
    "Psalm 69:30",
    "Psalm 71:5",
    "Psalm 71:14",
    "Psalm 72:18-19",
    "Psalm 73:24",
    "Psalm 73:28",
    "Psalm 77:11-12",
    "Psalm 78:4",
    "Psalm 81:10",
    "Psalm 84:2",
    "Psalm 84:5",
    "Psalm 85:6",
    "Psalm 86:11-12",
    "Psalm 89:1",
    "Psalm 90:1-2",
    "Psalm 91:11",
    "Psalm 92:4",
    "Psalm 94:18-19",
    "Psalm 95:6-7",
    "Psalm 96:4",
    "Psalm 97:10",
    "Psalm 98:1",
    "Psalm 100:5",
    "Psalm 101:2",
    "Psalm 102:1",
    "Psalm 103:2-3",
    "Psalm 103:13",
    "Psalm 104:1",
    "Psalm 105:4",
    "Psalm 106:1",
    "Psalm 108:1",
    "Psalm 111:2",
    "Psalm 112:1",
    "Psalm 113:3",
    "Psalm 116:5",
    "Psalm 118:6",
    "Psalm 118:14",
    "Psalm 119:11",
    "Psalm 119:16",
    "Psalm 119:28",
    "Psalm 119:30",
    "Psalm 119:33",
    "Psalm 119:45",
    "Psalm 119:67",
    "Psalm 119:71",
    "Psalm 119:76",
    "Psalm 119:105",
    "Psalm 119:114",
    "Psalm 119:130",
    "Psalm 119:147",
    "Psalm 119:162",
    "Psalm 119:165",
    "Psalm 121:1-2",
    "Psalm 122:1",
    "Psalm 125:1",
    "Psalm 126:3",
    "Psalm 127:3",
    "Psalm 128:1",
    "Psalm 130:7",
    "Psalm 131:3",
    "Psalm 135:3",
    "Psalm 138:1",
    "Psalm 138:8",
    "Psalm 139:7-8",
    "Psalm 139:13",
    "Psalm 140:6",
    "Psalm 141:3",
    "Psalm 143:10",
    "Psalm 144:15",
    "Psalm 145:8-9",
    "Psalm 146:5-6",
    "Psalm 147:5",
    "Psalm 147:11",
    "Psalm 148:13",
    "Psalm 149:4",

    // More Proverbs - Practical Wisdom
    "Proverbs 1:8",
    "Proverbs 2:1-2",
    "Proverbs 3:1-2",
    "Proverbs 3:7",
    "Proverbs 3:11-12",
    "Proverbs 4:7",
    "Proverbs 4:18",
    "Proverbs 6:6",
    "Proverbs 6:23",
    "Proverbs 8:13",
    "Proverbs 9:9",
    "Proverbs 10:1",
    "Proverbs 10:4",
    "Proverbs 10:19",
    "Proverbs 11:1",
    "Proverbs 11:2",
    "Proverbs 11:30",
    "Proverbs 12:1",
    "Proverbs 12:25",
    "Proverbs 13:1",
    "Proverbs 13:24",
    "Proverbs 14:1",
    "Proverbs 14:27",
    "Proverbs 15:13",
    "Proverbs 15:33",
    "Proverbs 16:9",
    "Proverbs 16:20",
    "Proverbs 16:32",
    "Proverbs 17:22",
    "Proverbs 18:10",
    "Proverbs 18:15",
    "Proverbs 19:11",
    "Proverbs 20:7",
    "Proverbs 21:21",
    "Proverbs 22:1",
    "Proverbs 22:4",
    "Proverbs 24:16",
    "Proverbs 25:11",
    "Proverbs 27:1",
    "Proverbs 28:1",
    "Proverbs 28:26",
    "Proverbs 29:25",
    "Proverbs 31:10",
    "Proverbs 31:30",

    // More Ecclesiastes - Life's Meaning
    "Ecclesiastes 2:24",
    "Ecclesiastes 3:14",
    "Ecclesiastes 4:9-10",
    "Ecclesiastes 5:1-2",
    "Ecclesiastes 7:14",
    "Ecclesiastes 8:12",
    "Ecclesiastes 9:10",
    "Ecclesiastes 12:1",
    "Ecclesiastes 12:7",

    // More Song of Solomon - Love
    "Song of Solomon 1:4",
    "Song of Solomon 2:4",
    "Song of Solomon 4:7",
    "Song of Solomon 6:3",

    // More Isaiah - Messianic & Comfort
    "Isaiah 2:3",
    "Isaiah 8:13",
    "Isaiah 9:2",
    "Isaiah 10:20",
    "Isaiah 11:2",
    "Isaiah 14:27",
    "Isaiah 25:8",
    "Isaiah 26:4",
    "Isaiah 28:16",
    "Isaiah 29:13",
    "Isaiah 32:17",
    "Isaiah 33:6",
    "Isaiah 35:4",
    "Isaiah 38:17",
    "Isaiah 42:6",
    "Isaiah 45:22",
    "Isaiah 46:9-10",
    "Isaiah 51:11",
    "Isaiah 52:10",
    "Isaiah 53:4",
    "Isaiah 55:1",
    "Isaiah 56:7",
    "Isaiah 58:6",
    "Isaiah 61:10",
    "Isaiah 63:7",
    "Isaiah 64:4",

    // More Jeremiah - Prophet of Tears
    "Jeremiah 1:7-8",
    "Jeremiah 3:22",
    "Jeremiah 6:16",
    "Jeremiah 7:23",
    "Jeremiah 14:22",
    "Jeremiah 16:19",
    "Jeremiah 17:7-8",
    "Jeremiah 20:11",
    "Jeremiah 23:6",
    "Jeremiah 26:13",
    "Jeremiah 29:14",
    "Jeremiah 31:33-34",
    "Jeremiah 32:40",
    "Jeremiah 33:11",

    // More Lamentations
    "Lamentations 2:19",
    "Lamentations 3:32-33",
    "Lamentations 3:41",
    "Lamentations 5:21",

    // More Ezekiel - Visions
    "Ezekiel 3:27",
    "Ezekiel 16:63",
    "Ezekiel 18:23",
    "Ezekiel 20:20",
    "Ezekiel 33:11",
    "Ezekiel 34:26",
    "Ezekiel 36:27",
    "Ezekiel 39:29",
    "Ezekiel 43:7",

    // More Daniel - Kingdom of God
    "Daniel 2:21",
    "Daniel 4:34-35",
    "Daniel 6:10",
    "Daniel 7:14",
    "Daniel 9:19",
    "Daniel 10:12",
    "Daniel 10:19",

    // More Hosea
    "Hosea 4:6",
    "Hosea 6:6",
    "Hosea 11:1",
    "Hosea 12:6",
    "Hosea 13:4",

    // More Joel
    "Joel 2:13",
    "Joel 2:26",
    "Joel 3:16",

    // More Amos
    "Amos 3:3",
    "Amos 4:12",
    "Amos 8:11",

    // Obadiah
    "Obadiah 1:17",
    "Obadiah 1:21",

    // More Jonah
    "Jonah 1:9",
    "Jonah 2:9",
    "Jonah 4:2",

    // More Micah
    "Micah 5:2",
    "Micah 6:8",
    "Micah 7:7",

    // More Nahum
    "Nahum 1:7",

    // More Habakkuk
    "Habakkuk 2:14",
    "Habakkuk 3:19",

    // More Zephaniah
    "Zephaniah 2:3",
    "Zephaniah 3:17",

    // More Haggai
    "Haggai 1:5",
    "Haggai 2:4-5",

    // More Zechariah
    "Zechariah 1:3",
    "Zechariah 3:2",
    "Zechariah 7:9",
    "Zechariah 8:3",
    "Zechariah 10:1",
    "Zechariah 13:9",

    // More Malachi
    "Malachi 1:11",
    "Malachi 2:10",
    "Malachi 3:1",
    "Malachi 3:16-17",
    "Malachi 4:5-6",

    // More Matthew - Sermon & Kingdom
    "Matthew 2:6",
    "Matthew 3:17",
    "Matthew 4:10",
    "Matthew 4:17",
    "Matthew 5:5",
    "Matthew 5:6",
    "Matthew 5:9",
    "Matthew 5:13",
    "Matthew 5:44",
    "Matthew 6:6",
    "Matthew 6:13",
    "Matthew 6:20",
    "Matthew 6:31-32",
    "Matthew 7:7-8",
    "Matthew 7:21",
    "Matthew 8:17",
    "Matthew 9:13",
    "Matthew 9:37-38",
    "Matthew 10:8",
    "Matthew 10:20",
    "Matthew 10:42",
    "Matthew 11:28-29",
    "Matthew 12:34",
    "Matthew 13:23",
    "Matthew 15:18-19",
    "Matthew 16:19",
    "Matthew 17:20",
    "Matthew 18:3-4",
    "Matthew 18:10",
    "Matthew 19:14",
    "Matthew 21:13",
    "Matthew 22:14",
    "Matthew 23:11-12",
    "Matthew 24:14",
    "Matthew 25:13",
    "Matthew 28:18",

    // More Mark - Servant Jesus
    "Mark 1:11",
    "Mark 1:17",
    "Mark 2:17",
    "Mark 4:24",
    "Mark 6:31",
    "Mark 9:24",
    "Mark 9:35",
    "Mark 10:14-15",
    "Mark 10:45",
    "Mark 12:29-30",
    "Mark 13:31",
    "Mark 14:38",

    // More Luke - Savior of All
    "Luke 1:46-47",
    "Luke 1:78-79",
    "Luke 2:14",
    "Luke 3:16",
    "Luke 4:8",
    "Luke 5:16",
    "Luke 6:12",
    "Luke 6:27-28",
    "Luke 6:31",
    "Luke 8:15",
    "Luke 9:48",
    "Luke 9:62",
    "Luke 10:20",
    "Luke 11:13",
    "Luke 12:12",
    "Luke 12:31",
    "Luke 13:24",
    "Luke 14:11",
    "Luke 14:27",
    "Luke 16:10",
    "Luke 17:3-4",
    "Luke 18:13-14",
    "Luke 22:42",
    "Luke 23:34",
    "Luke 24:47",

    // More John - Life & Light
    "John 1:4-5",
    "John 1:16-17",
    "John 2:5",
    "John 4:14",
    "John 5:39-40",
    "John 6:63",
    "John 6:68",
    "John 8:31-32",
    "John 10:11",
    "John 12:26",
    "John 13:14-15",
    "John 14:2",
    "John 14:6",
    "John 14:13-14",
    "John 14:18",
    "John 15:1-2",
    "John 15:10",
    "John 15:14-15",
    "John 16:7-8",
    "John 17:17",
    "John 17:21",
    "John 19:30",
    "John 21:15",

    // More Acts - Church Growth
    "Acts 1:8",
    "Acts 2:1-2",
    "Acts 2:44-45",
    "Acts 3:6",
    "Acts 4:12",
    "Acts 4:20",
    "Acts 5:38-39",
    "Acts 8:4",
    "Acts 9:31",
    "Acts 13:47",
    "Acts 16:31",
    "Acts 20:24",
    "Acts 26:18",

    // More Romans - Righteousness by Faith
    "Romans 1:20",
    "Romans 3:22-24",
    "Romans 5:6-8",
    "Romans 6:14",
    "Romans 7:24-25",
    "Romans 8:28",
    "Romans 8:37",
    "Romans 10:9-10",
    "Romans 11:36",
    "Romans 12:1-2",
    "Romans 13:10",
    "Romans 14:8",
    "Romans 15:7",

    // More 1 Corinthians
    "1 Corinthians 1:30-31",
    "1 Corinthians 2:5",
    "1 Corinthians 6:19-20",
    "1 Corinthians 10:13",
    "1 Corinthians 11:26",
    "1 Corinthians 13:4-7",
    "1 Corinthians 15:58",

    // More 2 Corinthians
    "2 Corinthians 1:21-22",
    "2 Corinthians 3:18",
    "2 Corinthians 4:17",
    "2 Corinthians 5:17",
    "2 Corinthians 6:2",
    "2 Corinthians 9:15",

    // More Galatians
    "Galatians 2:20",
    "Galatians 3:13-14",
    "Galatians 5:22-23",
    "Galatians 6:9",

    // More Ephesians
    "Ephesians 1:3",
    "Ephesians 2:4-5",
    "Ephesians 2:10",
    "Ephesians 3:20-21",
    "Ephesians 4:32",
    "Ephesians 5:18",
    "Ephesians 6:10-11",

    // More Philippians
    "Philippians 1:6",
    "Philippians 2:3-4",
    "Philippians 3:13-14",
    "Philippians 4:6-7",

    // More Colossians
    "Colossians 1:15-16",
    "Colossians 2:13-14",
    "Colossians 3:12-13",
    "Colossians 3:23-24",

    // More Thessalonians
    "1 Thessalonians 4:3-4",
    "1 Thessalonians 5:16-18",
    "2 Thessalonians 1:11-12",
    "2 Thessalonians 3:16",

    // More Timothy
    "1 Timothy 2:5-6",
    "1 Timothy 4:8",
    "2 Timothy 1:7",
    "2 Timothy 2:15",
    "2 Timothy 3:16-17",

    // More Titus & Philemon
    "Titus 2:13-14",
    "Titus 3:5-6",
    "Philemon 1:16",

    // More Hebrews - High Priest
    "Hebrews 1:3",
    "Hebrews 2:18",
    "Hebrews 4:15-16",
    "Hebrews 10:24-25",
    "Hebrews 12:1-2",
    "Hebrews 13:8",

    // More James
    "James 1:5-6",
    "James 1:17",
    "James 4:7-8",
    "James 5:16",

    // More Peter
    "1 Peter 1:8-9",
    "1 Peter 2:9",
    "1 Peter 3:15",
    "1 Peter 4:10-11",
    "1 Peter 5:7",
    "2 Peter 1:21",
    "2 Peter 3:9",

    // More 1 John
    "1 John 1:9",
    "1 John 2:15-16",
    "1 John 3:1",
    "1 John 4:4",
    "1 John 4:19",
    "1 John 5:4-5",

    // 2-3 John & Jude
    "2 John 1:9",
    "3 John 1:11",
    "Jude 1:3",

    // More Revelation - Victory & Glory
    "Revelation 1:3",
    "Revelation 2:7",
    "Revelation 3:20",
    "Revelation 5:13",
    "Revelation 7:12",
    "Revelation 15:4",
    "Revelation 19:16",
    "Revelation 21:6-7",
    "Revelation 22:12-13"
  ]
};

/**
 * Get a random verse reference from a specific difficulty level
 * @param {string} difficulty - "Beginner", "Intermediate", or "Advanced"
 * @returns {string} A random verse reference
 */
export function getRandomReferenceByDifficulty(difficulty = "Beginner") {
  const verses = VERSES_BY_DIFFICULTY[difficulty] || VERSES_BY_DIFFICULTY.Beginner;
  return verses[Math.floor(Math.random() * verses.length)];
}

/**
 * Get all verse references for a difficulty level
 * @param {string} difficulty - "Beginner", "Intermediate", or "Advanced"
 * @returns {Array<string>} Array of verse references
 */
export function getAllReferencesForDifficulty(difficulty = "Beginner") {
  return VERSES_BY_DIFFICULTY[difficulty] || VERSES_BY_DIFFICULTY.Beginner;
}

/**
 * Check if a reference exists in a difficulty level
 * @param {string} reference - Verse reference to check
 * @param {string} difficulty - Difficulty level
 * @returns {boolean} True if reference exists in that difficulty
 */
export function isReferenceInDifficulty(reference, difficulty) {
  const verses = VERSES_BY_DIFFICULTY[difficulty];
  if (!verses) return false;
  return verses.some(ref => ref === reference || reference.startsWith(ref));
}

export default {
  VERSES_BY_DIFFICULTY,
  getRandomReferenceByDifficulty,
  getAllReferencesForDifficulty,
  isReferenceInDifficulty
};
